module.exports = __webpack_public_path__ + "img/8.8e4ce956.png";